import { useMemo } from 'react';
import type { InteractiveMapMarker } from 'components/InteractiveMap';
import type { CultureIndexMapData } from 'types/Meteorology/Agro/CultureIndex/Area/getMapData';
import { findNearestValue } from 'helper/Meteorology/Agro/Maps/geoUtils';

export default function useEnrichedMarkers(
  markers: InteractiveMapMarker[] | undefined,
  mapData: CultureIndexMapData | undefined,
): InteractiveMapMarker[] {
  return useMemo(() => {
    if (!markers || !mapData?.length) return markers ?? [];
    return markers.map((marker) => {
      const [lat, lng] = marker.position;
      const val = findNearestValue(lat, lng, mapData);
      const tooltipExtra = val !== null
        ? { label: 'Índice [adm]', value: val.toFixed(2) }
        : undefined;
      return { ...marker, tooltipExtra };
    });
  }, [markers, mapData]);
}
